import List from 'containers/OrdersReturn/List';
import Show from 'containers/OrdersReturn/Show';
import Create from 'containers/OrdersReturn/Create';

export default { List, Create, Show };
